<template>
	<v-dialog persistent v-model="dialog" width=50%>
		<v-card class="px-2">
			<v-container>
				
				<v-row class="px-4 pt-4 pb-1">				
					<div><h3>Update complaint {{ claim }}</h3></div>					
					<v-spacer></v-spacer>
					<span class="ml-6 mt-1">
						<attm_button :attachments="attachments" :encrid="hokl_encrid" entity="hokl" :entitykey="claim" @updateData="updateAttachments"/>
					</span>							
					<span class="ml-6 mt-1">
						<mail_button :mails="mails" :encrid="hokl_encrid" @showDialog="showMailDialog"/>
					</span>						
				</v-row>
				<v-row dense class="px-2"><span style="font-size: small;">Duration <b>{{ hokl_normal_days }}</b> days, business days <b>{{ hokl_business_days }}</b></span></v-row>
                <v-row><v-divider></v-divider></v-row>
                <v-row class="pl-4 mt-6">
                    <owner_header :huov_encrid="huov_encrid" />
                </v-row>
                <v-row class="pl-4">
                    <caretaker_header :huov_encrid="huov_encrid" />
                </v-row>
                <v-row class="mt-6 mb-6"><v-divider></v-divider></v-row>

				<selections :reportedby="reportedby" :hokl_gebr="hokl_gebr" :hokl_klct_sel="hokl_klct_sel" :hokl_kloz_sel="hokl_kloz_sel"
                            :incident_slot="incident_slot" :customerLiable="customerLiable" @updateData="updateData"/>

				<v-card fluid flat class="mt-3">
                    <hokl_hosm_components title="Complaint components" :components="components" @updateData="updateData"/>
                </v-card>

				<v-row>
                    <v-col cols="12" class="pr-6">
                        <v-textarea v-model="hokl_memo" rows="3" label="Internal memo">{{ hokl_memo }}</v-textarea>
                    </v-col>
                </v-row>

				<v-card-actions>
					<v-spacer />
					<v-btn color="primary" small :disabled="!incident_slot" v-on:click="updHosm()">Save</v-btn>
					<v-btn color="primary" small v-on:click="closeDialog()">Close</v-btn>
				</v-card-actions>

			</v-container>
		</v-card>
		<mails_dialog ref="mailDialog" :width="'65%'"/>
	</v-dialog>
</template>

<script>

import owner_header from '@/components/huov/hokl/owner_header.vue'
import caretaker_header from '@/components/huov/hokl/caretaker_header.vue'
import mail_button from '@/components/ui/buttons/btn_mails.vue'
import attm_button from '@/components/huov/ui/attm_button.vue'
import hokl_hosm_components from '@/components/huov/ui/hokl_hosm_components.vue';
import mails_dialog from '@/components/huov/hokl/showMails.vue'
import selections from '@/components/huov/hokl/ui/screen_selections.vue';

export default {
	props: {
		huov_encrid: String
	},
	components: {
        owner_header,
        caretaker_header,		
		selections,
		hokl_hosm_components,	
		mail_button,
		attm_button,
		mails_dialog
	},
	data() {
		return {
			dialog: false,
			hokl_encrid: null,
			gebr_code: '',
			hokl_gebr: '',
			hokl_memo: '',
			hokl_business_days: 0,
			hokl_normal_days: 0,
			claim: '',
			claim_opened: '',
			attachments: 0,
			mails: 0,
			hokl_kloz_sel: [],
			hokl_klct_sel: [],
			reportedby: '',
			incident_slot: '',
			components:[{key: 0, description: '', amount: ''}], // start with 1 empty record
			customerLiable: false,
		}
	},
	methods: {
		open(hokl_encrid, claim, claim_opened) {			
			this.hokl_encrid = hokl_encrid;
			this.hokl_memo = '';
			this.attachments = 0;
			this.mails = 0;
			this.hokl_klct_sel = [];
			this.incident_slot = '';
			this.claim = claim;
			this.hokl_normal_days = 0;
			this.hokl_business_days = 0;
			this.claim_opened = claim_opened;
			this.components = [{key: 0, description: '', amount: ''}]; // start with 1 empty record
			this.getSingleHokl();
		},
		closeDialog() {
			this.$emit('updateData', 'refresh');
			this.dialog = false;
		},
		showMailDialog(encrid){
			this.$refs.mailDialog.open(encrid);
		},
		getSingleHokl() {
			this.$axios
				.post("ares/json/ares/huov/hokl/getSingleHokl.p", {
					header: {
						token: this.$session.get("ARES"),
						clientSessionId: this.$session.id(),
						request: "getSingleHokl"
					},
					getSingleHokl: {
						hokl_encrid: this.hokl_encrid
					}
				})
				.then(res => {
					if (res.data.error) {
						console.log(res.data.error);
						this.dialog = false; // do not show dialog
					} else {
						this.hokl_klct_sel = res.data.getSingleHokl.selected_klct;
						this.hokl_kloz_sel = res.data.getSingleHokl.selected_kloz;
						this.hokl_gebr = res.data.getSingleHokl.gebr_code;
						this.hokl_memo = res.data.getSingleHokl.hokl_memo;
						this.hokl_business_days = res.data.getSingleHokl.hokl_business_days;
						this.hokl_normal_days = res.data.getSingleHokl.hokl_normal_days;
						this.attachments = res.data.getSingleHokl.attachments;
						this.mails = res.data.getSingleHokl.mails;
						this.incident_slot = res.data.getSingleHokl.incident_slot;
						this.reportedby = res.data.getSingleHokl.reportedby;
						this.customerLiable = res.data.getSingleHokl.customerLiable;
						this.components = res.data.getSingleHokl.components;
						// now show dialog 
						this.dialog = true;
						this.loading = false;
					}
				});
		},
        updateData(data){
            this[data.field] = data.value;
        },		
        updateAttachments(){
			this.getSingleHokl();
        },				
		updHosm() {
			this.$axios
				.post("ares/json/ares/huov/hokl/updHokl.p", {
					header: {
						token: this.$session.get("ARES"),
						clientSessionId: this.$session.id(),
						request: "updHokl"
					},
					updHokl: {
						hokl_encrid: this.hokl_encrid,
						hokl_memo: this.hokl_memo,
						hokl_gebr: this.hokl_gebr,						
						selected_klct: this.hokl_klct_sel,
						selected_kloz: this.hokl_kloz_sel,
						reportedby: this.reportedby,
						incident_slot: this.incident_slot,
						customerLiable: this.customerLiable,
						components: this.components,
					}
				})
				.then(res => {
					if (res.data.error) {
						console.log(res.data.error);
						// laten we hopen dat dit nooit gebeurt, anders zetten we de gebruiker vast in dit dialog met een melding of iets (komt later)
					} else {
						this.closeDialog();
					}
				});
		}
	}
}
</script>

<style scoped>
</style>